var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"colors"},_vm._l((_vm.colors),function(color){return _c('div',{key:color,staticClass:"color",style:({background: color})})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }